import React from "react";

export const DraftsSkeleton: React.FC = () => {
  return (
    <div className="w-full mx-auto ">
      <style>{`
        @keyframes shimmer {
          0%   { background-position: -700px 0; }
          100% { background-position: 700px 0; }
        }

        .sk {
          background: linear-gradient(
            90deg,
            #e2ddf8 25%,
            #cfc8f0 50%,
            #e2ddf8 75%
          );
          background-size: 700px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
          display: block;
        }

        .wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .row {
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 14px 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .row-top {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
        }

        .row-left {
          display: flex;
          flex-direction: column;
          gap: 10px;
          flex: 1;
          min-width: 0;
        }

        .timestamp-row {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .sk-clock {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .sk-time {
          height: 13px;
          border-radius: 5px;
        }

        .icons-row {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .sk-icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .row-right {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
        }

        .sk-btn {
        
          width: 45px;
          height: 30px;
          border-radius: 8px;
        }

        .sk-arrow {
          width: 18px;
          height: 18px;
          border-radius: 4px;
        }

        @media (max-width: 640px) {
          .row-top {
            flex-direction: column;
            align-items: stretch;
          }

          .row-right {
            justify-content: flex-end;
          }
        }
      `}</style>

      <div className="wrapper">
        {[...Array(7)].map((_, index) => {
          const iconCount = [4, 1, 2, 1, 1, 1, 1][index % 7];
          const timeWidth = [130, 130, 130, 130, 130, 130, 130][index % 7];

          return (
            <div key={index} className="row">
              <div className="flex flex-col gap-2 flex-1">
                {/* top row: time + buttons */}
                <div className="flex items-center justify-between">
                  <div className="timestamp-row">
                    <div className="sk sk-clock"></div>
                    <div
                      className="sk sk-time"
                      style={{ width: `${timeWidth}px` }}
                    ></div>
                  </div>

                  <div className="row-right">
                    <div className="sk sk-btn"></div>
                    <div className="sk sk-arrow"></div>
                  </div>
                </div>

                {/* icons row */}
                <div className="icons-row">
                  {[...Array(iconCount)].map((_, j) => (
                    <div key={j} className="sk sk-icon"></div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
